import { render, staticRenderFns } from "./RefPricingUpload.vue?vue&type=template&id=2b21e529&"
import script from "./RefPricingUpload.vue?vue&type=script&lang=js&"
export * from "./RefPricingUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports